import { If, TabLink } from "components";
import { t } from "i18next";
import { ContentLayout } from "layouts";
import { Routes } from "modules/common";
import {
  MarketingCampaigns,
  MarketingContacts,
  MarketingFlows,
  MarketingTemplates
} from "modules/marketing";
import { useParams } from "react-router-dom";

import styles from "./MarketingPage.module.scss";

const MarketingPage = () => {
  const { activeTab } = useParams();
  const marketingRoutes = Routes.find((route) => {
    return route.label === "Marketing";
  })?.nestedRoutes;

  return (
    <ContentLayout title={t("Marketing")}>
      <div className={styles.page}>
        <If condition={!!marketingRoutes}>
          <nav className={styles.page__tabs}>
            {marketingRoutes?.map((route) => (
              <TabLink
                key={route.label}
                pathName={route.path}
                label={t(route.label)}
              />
            ))}
          </nav>
        </If>

        <If condition={activeTab === "contacts"}>
          <MarketingContacts />
        </If>

        <If condition={activeTab === "templates"}>
          <MarketingTemplates />
        </If>

        <If condition={activeTab === "campaigns"}>
          <MarketingCampaigns />
        </If>

        <If condition={activeTab === "flows"}>
          <MarketingFlows />
        </If>
      </div>
    </ContentLayout>
  );
};

export default MarketingPage;
